<ng-container *ngIf="timer$ | async as timer">
  <span *ngIf="mode !== 'numbers'; else numbersTpl" class="resend-counter">
    {{ template ? (template | translate: { timer: getFormattedTimer(timer) }) : getFormattedTimer(timer) }}
  </span>

  <ng-template #numbersTpl>
    <div class="counter" [class.counter--static]="!isResponsive">
      <ng-container *ngIf="timer.days">
        <ng-container *ngTemplateOutlet="charTmpl; context: { chars: timer.days }"></ng-container>
        <div class="counter__item counter__item--colon">
          <span class="counter__colon">:</span>
        </div>
      </ng-container>
      <ng-container *ngIf="timer.hours">
        <ng-container *ngTemplateOutlet="charTmpl; context: { chars: timer.hours }"></ng-container>
        <div *ngIf="timer.minutes" class="counter__item counter__item--colon">
          <span class="counter__colon">:</span>
        </div>
      </ng-container>
      <ng-container *ngIf="timer.minutes">
        <ng-container *ngTemplateOutlet="charTmpl; context: { chars: timer.minutes }"></ng-container>
      </ng-container>

      <ng-container *ngIf="timer.seconds">
        <div class="counter__item counter__item--colon">
          <span class="counter__colon">:</span>
        </div>
        <ng-container *ngTemplateOutlet="charTmpl; context: { chars: timer.seconds }"></ng-container>
      </ng-container>
    </div>

    <ng-template #charTmpl let-chars="chars">
      <div class="counter__item" dir="ltr">
        <span class="counter__number" *ngFor="let char of chars.split('')">{{ char }}</span>
      </div>
    </ng-template>

    <ng-container *ngIf="hasCountNames">
      <ng-container *ngIf="isResponsive; else mobileNames">
        <responsive [screens]="[screenType.tablet, screenType.desktop]">
          <div class="counter-names">
            <div *ngIf="timer.days" class="counter-names__block">
              <span translate="countdown.timer.days"></span>
            </div>
            <div *ngIf="timer.hours" class="counter-names__block">
              <span translate="countdown.timer.hours"></span>
            </div>
            <div *ngIf="timer.minutes" class="counter-names__block">
              <span translate="countdown.timer.minutes"></span>
            </div>
            <div *ngIf="timer.seconds" class="counter-names__block">
              <span translate="countdown.timer.seconds"></span>
            </div>
          </div>
        </responsive>
        <responsive [screens]="[screenType.mobile]">
          <ng-container [ngTemplateOutlet]="mobileNames"></ng-container>
        </responsive>
      </ng-container>
    </ng-container>

    <ng-template #mobileNames>
      <div class="counter-names" [class.counter-names--static]="!isResponsive">
        <div *ngIf="timer.days" class="counter-names__block">
          <span translate="countdown.timer.days.abbr"></span>
        </div>
        <div *ngIf="timer.hours" class="counter-names__block">
          <span translate="countdown.timer.hours.abbr"></span>
        </div>
        <div *ngIf="timer.minutes" class="counter-names__block">
          <span translate="countdown.timer.minutes.abbr"></span>
        </div>
        <div *ngIf="timer.seconds" class="counter-names__block">
          <span translate="countdown.timer.seconds.abbr"></span>
        </div>
      </div>
    </ng-template>
  </ng-template>
</ng-container>
